export default __webpack_public_path__ + "static/media/IMG_0059_5_11zon.be0b8187.jpg";